import React from "react";
import cx from "classnames";
import { t } from "@lingui/macro";
import "./Footer.css";
// import logoImg from "img/ic_gmx_footer.svg";

import logoImg from "img/footer-Logo.svg";
// import twitterIcon from "img/ic_twitter.svg";
// import twitterIcon from "img/ic_twitter-1.svg";
// import discordIcon from "img/ic_discord.svg";
// import telegramIcon from "img/ic_telegram.svg";
// import telegramIcon from "img/ic_telegram-1.svg";
// import githubIcon from "img/ic_github.svg";
// import githubIcon from "img/ic_github-1.svg";
// import mediumIcon from "img/ic_medium.svg";
// import mediumIcon from "img/ic_medium-1.svg";
import { NavLink } from "react-router-dom";
import { isHomeSite, getAppBaseUrl, shouldShowRedirectModal } from "lib/legacy";
import githubIcon from "img/discord_line.svg";
import youtubeIcon from "img/youtube_line.svg";
import telegramIcon from "img/telegram_line.svg";
import twitterIcon from "img/twitter_line.svg";
import mediumIcon from "img/medium-line.svg"
import frameIcon from "img/frame.svg"
import smallFrameIcon from "img/small_Frame.svg"
import smallDiscordIcon from "img/small_discord_line.svg"
import smallMediumIcon from "img/small_medium.svg"
import smallTelegramIcon from "img/smalltelegram_line.svg"
import smallTwitterIcon from "img/small_twitter_line.svg"
import smallYoutubeIcon from "img/small_youtube_line.svg"
const footerLinks = {
  home: [
    { text: t`Terms and Conditions`, link: "/terms-and-conditions" },
    { text: t`Referral Terms`, link: "/referral-terms" },
    // { text: t`Media Kit`, link: "https://gmxio.gitbook.io/gmx/media-kit", external: true },
    { text: t`Media Kit`, link: "", external: true },
    // { text: "Jobs", link: "/jobs", isAppLink: true },
  ],
  app: [
    // { text: t`Media Kit`, link: "https://gmxio.gitbook.io/gmx/media-kit", external: true },
    { text: t`Media Kit`, link: "", external: true },
    // { text: "Jobs", link: "/jobs" },
  ],
};

const socialLinks = [
  { link: "https://twitter.com/GMX_IO", name: "Twitter", icon: twitterIcon },
  { link: "https://medium.com/@gmx.io", name: "Medium", icon: mediumIcon },
  { link: "https://github.com/gmx-io", name: "Github", icon: githubIcon },
  { link: "https://t.me/GMX_IO", name: "Telegram", icon: telegramIcon },
  // { link: "https://discord.gg/cxjZYR4gQK", name: "Discord", icon: discordIcon },
];

export default function Footer ({ showRedirectModal, redirectPopupTimestamp, isHomePage }) {
  const isHome = isHomeSite();

  return (
    <div className="Footer">
      <div className={cx("Footer-wrapper", { home: isHome })}>
        <div className="Footer-logo">
          <img src={logoImg} alt="AVT" />
        </div>
        {!isHomePage && <div className="Footer-social-link-block">
          <a href="https://bit.ly/3Z3ZrrD" target="_blank" className="App-social-link">
            <img src={frameIcon} alt="" className="big" />
            <img src={smallFrameIcon} alt="" className="small" />
          </a>
          <a href="https://twitter.com/AVTtrade" target="_blank" className="App-social-link">
            <img src={twitterIcon} alt="" className="big" />
            <img src={smallTwitterIcon} alt="" className="small" />
          </a>
          <a href="https://medium.com/@avttrade" target="_blank" className="App-social-link">
            <img src={mediumIcon} alt="" className="big" />
            <img src={smallMediumIcon} alt="" className="small" />
          </a>
          <a href="https://t.me/AVTWorld" target="_blank" className="App-social-link">
            <img src={telegramIcon} alt="" className="big" />
            <img src={smallTelegramIcon} alt="" className="small" />
          </a>
          <a href="https://discord.gg/DprCJcfCyg" target="_blank" className="App-social-link">
            <img src={githubIcon} alt="" className="big" />
            <img src={smallDiscordIcon} alt="" className="small" />
          </a>
          <a href="https://bit.ly/3QcNko9" target="_blank" className="App-social-link">
            <img src={youtubeIcon} alt="" className="big" />
            <img src={smallYoutubeIcon} alt="" className="small" />
          </a>
        </div>
        }

        <div className="Copy-right">
          Copyright &#169; 2023 All Rights Reserved
        </div>
        {/* <div className="Footer-social-link-block">
          {socialLinks.map((platform) => {
            return (
              <a
                key={platform.name}
                className="App-social-link"
                href={platform.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={platform.icon} alt={platform.name} />
              </a>
            );
          })}
        </div> */}
        {/* <div className="Footer-links">
          {footerLinks[isHome ? "home" : "app"].map(({ external, text, link, isAppLink }) => {
            if (external) {
              return (
                <a key={text} target="_blank" href={link} className="Footer-link" rel="noopener noreferrer">
                  {text}
                </a>
              );
            }
            if (isAppLink) {
              if (shouldShowRedirectModal(redirectPopupTimestamp)) {
                return (
                  <div key={text} className="Footer-link a" onClick={() => showRedirectModal(link)}>
                    {text}
                  </div>
                );
              } else {
                const baseUrl = getAppBaseUrl();
                return (
                  <a key={text} href={baseUrl + link} className="Footer-link">
                    {text}
                  </a>
                );
              }
            }
            return (
              <NavLink key={link} to={link} className="Footer-link" activeClassName="active">
                {text}
              </NavLink>
            );
          })}
        </div> */}
      </div>
    </div>
  );
}
